module.exports = __webpack_public_path__ + "static/media/target_lv_4fc67c03c55783cb54d059f4d40e9d83e.webp";